import { BoxFC } from 'components/BoxCustom'
import React from 'react'
import TripPaymentBoard from './TripPaymentBoard'

const DriverTripPaymentV3 = () => {
  return (
    <BoxFC height='100%'>
      <TripPaymentBoard />
    </BoxFC>
  )
}

export default DriverTripPaymentV3
